module.exports = __webpack_public_path__ + "src/assets/en.fd266848.png";